import { useNavigate } from "react-router-dom";
import { NotificationTableRow_notification$data } from "../__generated__/NotificationTableRow_notification.graphql";
import { ENGAGE_DAILY_DEALS } from "../../../../../utils/routes";

const useNavigateToEditNotification = () => {
  const navigate = useNavigate();
  return (notification: NotificationTableRow_notification$data) => {
    const dailyDealID = notification.dailyDeal?.id;
    const feedPostID = notification.feedPost?.id;
    const highlightID = notification.highlight?.id;
    if (dailyDealID != null) {
      navigate(`${ENGAGE_DAILY_DEALS}/edit/${dailyDealID}`);
    } else if (feedPostID != null) {
      navigate(`/engage/feed/edit/${feedPostID}`);
    } else if (highlightID != null) {
      navigate(`/engage/highlights`, {
        state: {
          albumID: notification.highlight?.highlightAlbum.id,
          highlightID: highlightID,
        },
      });
    } else {
      navigate(`/engage/notifications/edit/${notification.id}`);
    }
  };
};

export default useNavigateToEditNotification;
